<template>
  <div class="brands-section">
    <div class="section">
      <span class="brands-eyebrow reveal">Brands we carry</span>
    </div>
    <div class="brands-marquee-wrap">
      <div class="brands-track">
        <a
          v-for="(b, i) in loopedBrands"
          :key="'br-' + i"
          :href="b.href"
          class="brand-name"
          >{{ b.name }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutBrandsStrip",
  props: {
    brands: {
      type: Array,
      required: true,
    },
  },
  computed: {
    loopedBrands() {
      return [...this.brands, ...this.brands];
    },
  },
};
</script>
